import { Component, ViewChild, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { TeacherSidenavbarComponent } from '../../dashboard/teacher/teacher-navbar/teacher-sidenavbar/teacher-sidenavbar.component';
import { MatSidenav } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TopNavbarComponent } from '../../student-dashboard-v2/top-navbar/top-navbar.component';

@Component({
    selector: 'app-mentor-panel-layout',
    standalone: true,
    imports: [SharedModule, RouterModule, TeacherSidenavbarComponent, TopNavbarComponent],
    templateUrl: './mentor-panel-layout.component.html',
    styleUrl: './mentor-panel-layout.component.scss'
})
export class MentorPanelLayoutComponent implements OnInit {
    @ViewChild(MatSidenav) sidenav!: MatSidenav;
    collapsed: boolean = false;
    isMobile: boolean = false;
    private touchStartX: number = 0;
    private touchEndX: number = 0;

    constructor(private observer: BreakpointObserver) { }

    ngOnInit() {
        this.observer.observe(['(max-width: 1024px)']).subscribe((screen) => {
            if (screen.matches) {
                this.isMobile = true;
                this.collapsed = false;
                if (this.sidenav) {
                    this.sidenav.close();
                }
            } else {
                this.isMobile = false;
                this.collapsed = false;
                if (this.sidenav) {
                    this.sidenav.open();
                }
            }
        });
    }

    onTouchStart(event: TouchEvent) {
        this.touchStartX = event.changedTouches[0].screenX;
    }

    onTouchEnd(event: TouchEvent) {
        this.touchEndX = event.changedTouches[0].screenX;
        this.handleSwipe();
    }

    private handleSwipe() {
        const swipeDistance = this.touchStartX - this.touchEndX;
        if (this.isMobile && swipeDistance > 50 && this.sidenav && this.sidenav.opened) {
            this.sidenav.close();
        }
    }

    toggleSidenav() {
        if (this.isMobile) {
            this.sidenav.toggle();
        } else {
            this.collapsed = !this.collapsed;
        }
    }

    closeSidenav() {
        if (this.isMobile) {
            this.sidenav.close();
        }
    }
}

